import React from "react";
import { createPortal } from "react-dom";
import { useBodyScrollLock } from "@hooks";
import { useGeniusRegistration } from "./GeniusRegistrationContext";
import { REGISTRATION_STEPS } from "./constants";
import { IntentStep } from "./steps/IntentStep";
import { PhoneOtpStep } from "./steps/PhoneOtpStep";
import { StudentFormStep } from "./steps/StudentFormStep";
import { SchoolFormStep } from "./steps/SchoolFormStep";
import { SuccessStep } from "./steps/SuccessStep";
import styles from "./GeniusRegistrationModal.module.css";

const StepContent = () => {
  const { step } = useGeniusRegistration();

  switch (step) {
    case REGISTRATION_STEPS.INTENT:
      return <IntentStep />;
    case REGISTRATION_STEPS.PHONE:
    case REGISTRATION_STEPS.OTP:
      return <PhoneOtpStep />;
    case REGISTRATION_STEPS.STUDENT_FORM:
      return <StudentFormStep />;
    case REGISTRATION_STEPS.SCHOOL_FORM:
      return <SchoolFormStep />;
    case REGISTRATION_STEPS.SUCCESS:
      return <SuccessStep />;
    default:
      return null;
  }
};

export const GeniusRegistrationModal = () => {
  const { isOpen, closeRegistration } = useGeniusRegistration();
  useBodyScrollLock(isOpen);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`${styles.backdrop} ${styles.geniusRegModal}`}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeRegistration();
      }}
    >
      <StepContent />
    </div>,
    document.body
  );
};
